import React, { Component } from "react";
import { connect } from "react-redux";

import { Wrapper, Row, Card } from "app/NativeComponents/common";
import { Header } from "app/NativeComponents/snippets";

import { loadOnboardingLandingPage } from "app/NativeActions";

import VideoCard from "./VideoCard";
import News from "app/DealMachineCore/components/Dashboard/News";
import Features1Card from "./Features1Card";
import Quote from "app/DealMachineCore/snippets/Quote";
import BottomSection from "./BottomSection";

class OnboardingLandingPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onboarding_landing_page: null,
      loading: true
    };
  }

  componentDidMount() {
    loadOnboardingLandingPage(this.props.slug)
      .then(data => {
        if (data && data.items) {
          if (data.items.length > 0) {
            this.setState({
              onboarding_landing_page: data.items[0]
                ? data.items[0].fields
                  ? data.items[0].fields
                  : null
                : null,
              loading: false
            });
          }
        }
        this.setState(() => ({ loading: false }));
      })
      .catch(err => {
        this.setState(() => ({ loading: false }));
      });
  }

  componentDidUpdate(prevProps) {}

  renderQuotes(onboarding_landing_page) {
    if (!this.props.dashboardMobile) {
      return (
        <Wrapper
          style={{
            borderLeftWidth: 1,
            borderLeftStyle: "solid",
            borderLeftColor: this.props.colors.border_color,
            minWidth: 250,
            alignSelf: "stretch",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Quote
            style={{ padding: 25, paddingTop: 50 }}
            center={true}
            title={onboarding_landing_page.quoteTitle}
            description={onboarding_landing_page.quoteDescription}
          />
          <Quote
            style={{ padding: 25, paddingTop: 50, paddingBottom: 50 }}
            center={true}
            title={onboarding_landing_page.quoteTitle2}
            description={onboarding_landing_page.quoteDescription2}
          />
        </Wrapper>
      );
    }
  }

  render() {
    const { loading, onboarding_landing_page } = this.state;
    const { onboarding_info } = this.props;
    if (loading == false && onboarding_landing_page != null) {
      return (
        <Wrapper
          style={{
            paddingTop: 0,
            paddingBottom: 20,
            padding: this.props.dashboardMobile ? 0 : 20
          }}
        >
          <Row
            style={{
              flexDirection: this.props.dashboardMobile ? "column" : "row"
            }}
          >
            <VideoCard
              {...this.props}
              onboarding_landing_page={onboarding_landing_page}
              onboarding_info={onboarding_info}
            />
            <News {...this.props} />
          </Row>
          <Wrapper style={{ alignSelf: "stretch", flex: 1 }}>
            <Card style={{ flex: 1, overflow: "hidden" }}>
              <Wrapper
                style={{
                  flexDirection: this.props.dashboardMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Wrapper>
                  <Features1Card
                    {...this.props}
                    onboarding_landing_page={onboarding_landing_page}
                  />
                  <BottomSection
                    {...this.props}
                    onboarding_landing_page={onboarding_landing_page}
                  />
                </Wrapper>
                <Wrapper
                  style={{
                    paddingTop: 25,
                    paddingBottom: 25,
                    alignSelf: "stretch",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  {this.renderQuotes(onboarding_landing_page)}
                </Wrapper>
              </Wrapper>
            </Card>
          </Wrapper>
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}

const mapStateToProps = ({ auth, native, billing, settings }) => {
  const { token, user } = auth;
  const { device, platform, dashboardMobile, isMobile } = native;
  const { colors } = settings;
  const { card_info } = billing;
  return {
    token,
    user,
    device,
    platform,
    dashboardMobile,
    isMobile,
    card_info,
    colors
  };
};
export default connect(mapStateToProps, {})(OnboardingLandingPage);
